import { API } from "aws-amplify";
import StudentInformationService from "./StudentInformationService";
import { formatGuidForSIS } from "./util";

export let studentUser;
export let schoolStudentUser;

export const listParentPortalAccessKeys = /* GraphQL */ `
  query ListParentPortalAccessKeys(
    $filter: ModelParentPortalAccessKeyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listParentPortalAccessKeys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        studentId
        parentEmail
        homeStudentId
        teacherEmail
        parentPhone
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const accessKeyByStudentId = /* GraphQL */ `
  query AccessKeyByStudentId(
    $studentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelParentPortalAccessKeyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accessKeyByStudentId(
      studentId: $studentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        studentId
        parentEmail
        homeStudentId
        teacherEmail
        parentPhone
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export async function getAccessKeyByStudentId(studentId) {
  const url = process.env.PARENT_PORTAL_SERVICE_URL;
  const apiKey = process.env.PARENT_PORTAL_SERVICE_KEY;

  const data = await graphQLRequest(url, apiKey, listParentPortalAccessKeys, {
    filter: { studentId: { eq: studentId } },
  });

  studentUser = data.data.listParentPortalAccessKeys.items[0];

  return studentUser;
}

export const graphQLRequest = (url, apiKey, query, variables, retries = 3) => {
  const variablesString = JSON.stringify(variables);
  const controller = new AbortController();
  const fetchTimeout = setTimeout(() => {
    controller.abort();
  }, 7000);

  return fetch(url, {
    method: "POST",
    headers: {
      "x-api-key": apiKey,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ query, variables }),
    signal: controller.signal,
  })
    .then((res) => {
      return res.json();
    })
    .then((res) => {
      clearTimeout(fetchTimeout);
      // GraphQL does not throw an error if the request failed. Instead, it populates the res.errors array
      if (!res.errors) {
        return Promise.resolve(res);
      } else {
        if (retries > 0) {
          return graphQLRequest(url, apiKey, query, variables, retries - 1);
        } else {
          return Promise.reject(res.errors[0].message);
        }
      }
    })
    .catch((err) => {
      clearTimeout(fetchTimeout);
      if (retries > 0) {
        return graphQLRequest(url, apiKey, query, variables, retries - 1);
      } else {
        return Promise.reject(err);
      }
    });
};